import { render } from "./audit-log.vue?vue&type=template&id=71257787"
import script from "./audit-log.vue?vue&type=script&lang=js"
export * from "./audit-log.vue?vue&type=script&lang=js"

import "./audit-log.vue?vue&type=style&index=0&id=71257787&lang=scss"

import exportComponent from "../../../../../node_modules/rspack-vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__